<template>
  <section class="case-studies-section position-relative see__pad">
    <div class="container">
      <div class="swiper case-studies-swiper">
        <div class="swiper-wrapper">
          <div 
            v-for="(study, index) in content.caseStudies" 
            :key="index"
            class="swiper-slide"
          >
            <div class="row">
              <div class="d-none d-md-block col-lg-6 col-md-12">
                <div class="case-studies-visual">
                  <div class="visual-background">
                    <div class="background-shape"></div>
                  </div>
                  <div class="main-image">
                    <img :src="study.image" :alt="study.altText" />
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-md-12">
                <div class="case-studies-content">
                  <div class="case-study-label">
                    <span>{{ content.sectionLabel }}</span>
                  </div>
                  <div class="case-study-title">
                    <h2>{{ study.title }}</h2>
                  </div>
                  <div class="case-study-description">
                    <p>{{ study.description }}</p>
                  </div>
                  <div class="case-study-stats">
                    <div 
                      v-for="(stat, statIndex) in study.stats" 
                      :key="statIndex"
                      class="stat-item"
                    >
                      <span class="stat-number" :data-count="stat.number">0</span>
                      <span class="stat-label">{{ stat.label }}</span>
                    </div>
                  </div>
                  <div class="case-study-meta">
                    <div class="meta-item">
                      <span class="meta-label">Industry:</span>
                      <span class="meta-value">{{ study.industry }}</span>
                    </div>
                    <div class="meta-item">
                      <span class="meta-label">Technology:</span>
                      <span class="meta-value">{{ study.technology }}</span>
                    </div>
                  </div>
                  <div class="case-study-cta">
                    <router-link :to="study.ctaLink" class="case-study-btn">
                      {{ study.ctaText }} <i class="icon-02"></i>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Navigation buttons -->
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HomeItsCaseStudiesComp",
  props: {
    content: {
      type: Object,
      required: true,
      default: () => ({
        sectionLabel: "Case Studies",
        caseStudies: [
          {
            title: "Cross-Platform Mobile App for Fitness & Wellness",
            description: "We created a comprehensive fitness tracking mobile application with social features, workout plans, and nutrition tracking. The app includes real-time health monitoring, community challenges, and personalized coaching recommendations for users worldwide.",
            image: "@/assets/images/resource/service-details.jpg",
            altText: "Agriculture Case Study",
            industry: "Mobile Development",
            technology: "React Native, Firebase",
            ctaText: "Read More",
            ctaLink: "/case-studies",
            stats: [
              {
                number: 2.5,
                label: "M Downloads"
              },
              {
                number: 4.8,
                label: "App Store Rating"
              }
            ]
          },
          {
            title: "E-Commerce Platform with Advanced Analytics",
            description: "Built a full-featured online marketplace with inventory management, payment processing, and customer analytics. The platform includes AI-powered product recommendations, multi-vendor support, and comprehensive reporting dashboard for business insights.",
            image: "@/assets/images/resource/portfolio-01.jpg",
            altText: "Manufacturing Case Study",
            industry: "E-Commerce",
            technology: "Vue.js, Laravel, MySQL",
            ctaText: "Read More",
            ctaLink: "/case-studies",
            stats: [
              {
                number: 500,
                label: "K+ Products"
              },
              {
                number: 150,
                label: "% Revenue Growth"
              }
            ]
          },
          {
            title: "Multiplayer Gaming Platform with Real-Time Features",
            description: "Developed an immersive multiplayer gaming platform featuring real-time chat, leaderboards, tournament systems, and in-game purchases. The platform supports thousands of concurrent players with low-latency gameplay and advanced matchmaking algorithms.",
            image: "@/assets/images/resource/portfolio-02.jpg",
            altText: "Fintech Case Study",
            industry: "Gaming",
            technology: "Unity, WebSocket, Redis",
            ctaText: "Read More",
            ctaLink: "/case-studies",
            stats: [
              {
                number: 100,
                label: "K+ Active Players"
              },
              {
                number: 15,
                label: "ms Latency"
              }
            ]
          }
        ]
      })
    }
  }
}
</script>

<style scoped>
/* Case Studies Section Styles */
.case-studies-section {
  padding: 100px 0;
  background: #fff;
  position: relative;
}

.case-studies-visual {
  position: relative;
  height: 500px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 20px;
}

.visual-background {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  z-index: 1;
  width: 80%;
  height: 100%;
}

.background-shape {
  width: 45%;
  height: 100%;
  background: #e3f2fd;
  border-radius: 25px;
  position: relative;
}

.main-image {
  position: absolute;
  top: 50%;
  left: 20%;
  transform: translateY(-50%);
  z-index: 2;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
  width: 60%;
  max-width: 350px;
}

.main-image img {
  width: 100%;
  height: 280px;
  object-fit: cover;
  display: block;
}

.case-studies-content {
  padding: 40px 0;
  height: 500px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.case-studies-swiper {
  width: 100%;
  height: 600px;
}

.case-study-label {
  margin-bottom: 15px;
}

.case-study-label span {
  font-size: 16px;
  font-weight: 600;
  color: #C00A87;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-family: 'Archivo', sans-serif;
}

.case-study-title h2 {
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
  color: #2c3e50;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
}

.case-study-description p {
  font-size: 16px;
  line-height: 26px;
  color: #6c757d;
  margin-bottom: 30px;
  font-family: 'Open Sans', sans-serif;
}

.case-study-stats {
  display: flex;
  gap: 30px;
  margin-bottom: 25px;
}

.stat-item {
  text-align: center;
}

.stat-number {
  font-size: 32px;
  font-weight: 700;
  color: #C00A87;
  display: block;
  font-family: 'Archivo', sans-serif;
}

.stat-label {
  font-size: 14px;
  color: #6c757d;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-family: 'Open Sans', sans-serif;
}

.case-study-meta {
  display: flex;
  gap: 30px;
  margin-bottom: 30px;
}

.meta-item {
  display: flex;
  flex-direction: column;
}

.meta-label {
  font-size: 14px;
  color: #6c757d;
  font-weight: 600;
  margin-bottom: 5px;
  font-family: 'Open Sans', sans-serif;
}

.meta-value {
  font-size: 16px;
  color: #2c3e50;
  font-weight: 700;
  font-family: 'Archivo', sans-serif;
}

.case-study-btn {
  display: inline-flex;
  align-items: center;
  padding: 12px 24px;
  background: #C00A87;
  color: #fff;
  text-decoration: none;
  border-radius: 25px;
  font-family: 'Archivo', sans-serif;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.case-study-btn i {
  margin-left: 8px;
  font-size: 14px;
  transition: transform 0.3s ease;
}

.case-study-btn:hover {
  background: transparent;
  color: #C00A87;
  border-color: #C00A87;
  text-decoration: none;
}

.case-study-btn:hover i {
  transform: translateX(3px);
}

/* Swiper Navigation Buttons for Case Studies */
.case-studies-swiper .swiper-button-next,
.case-studies-swiper .swiper-button-prev {
  background: #C00A87;
  border: none;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 5px 15px rgba(192, 10, 135, 0.3);
  position: absolute;
  bottom: 20px;
  top: auto;
  margin-top: 0;
  z-index: 10;
}

.case-studies-swiper .swiper-button-prev {
  left: 50%;
  transform: translateX(-60px);
}

.case-studies-swiper .swiper-button-next {
  right: 50%;
  transform: translateX(60px);
}

.case-studies-swiper .swiper-button-next:hover,
.case-studies-swiper .swiper-button-prev:hover {
  background: #a0086b;
  transform: scale(1.1);
  box-shadow: 0 8px 20px rgba(192, 10, 135, 0.4);
}

.case-studies-swiper .swiper-button-prev:hover {
  transform: translateX(-60px) scale(1.1);
}

.case-studies-swiper .swiper-button-next:hover {
  transform: translateX(60px) scale(1.1);
}

.case-studies-swiper .swiper-button-next:after,
.case-studies-swiper .swiper-button-prev:after {
  font-size: 18px;
  font-weight: 600;
}

/* Responsive Design */
@media only screen and (max-width: 991px) {
  .case-studies-section {
    padding: 80px 0;
  }
}

@media only screen and (max-width: 767px) {
  .case-studies-section {
    padding: 60px 0;
  }
  .case-studies-visual {
    height: 400px;
    margin-bottom: 40px;
    padding-left: 10px;
  }

  .visual-background {
    width: 90%;
    height: 60%;
  }

  .main-image {
    width: 70%;
    max-width: 280px;
    right: -5%;
  }

  .main-image img {
    height: 220px;
  }

  .case-studies-content {
    height: auto;
    padding: 20px 0;
    justify-content: flex-start;
  }

  .case-studies-swiper {
    height: auto;
  }

  .case-study-title h2 {
    font-size: 28px;
    line-height: 38px;
  }

  .case-study-stats {
    gap: 20px;
  }

  .case-study-meta {
    gap: 20px;
  }
}

@media only screen and (max-width: 399px) {
  .case-studies-section {
    padding: 40px 0;
  }
  
  .case-study-title h2 {
    font-size: 24px;
    line-height: 32px;
  }

  .case-study-stats {
    flex-direction: column;
    gap: 15px;
  }

  .case-study-meta {
    flex-direction: column;
    gap: 15px;
  }

  .case-studies-swiper .swiper-button-next,
  .case-studies-swiper .swiper-button-prev {
    width: 40px;
    height: 40px;
    font-size: 14px;
    bottom: 10px;
  }

  .case-studies-swiper .swiper-button-prev {
    transform: translateX(-50px);
  }

  .case-studies-swiper .swiper-button-next {
    transform: translateX(50px);
  }

  .case-studies-swiper .swiper-button-prev:hover {
    transform: translateX(-50px) scale(1.1);
  }

  .case-studies-swiper .swiper-button-next:hover {
    transform: translateX(50px) scale(1.1);
  }
  
  .case-studies-swiper .swiper-button-next:after,
  .case-studies-swiper .swiper-button-prev:after {
    font-size: 14px;
  }
}
</style>
